import React from 'react';
import { RenderNode } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

import { BlockContainer, Layout, Column } from '../../Layout';
import { Text } from '../../Text';
import RichText from '../../RichText';

import { Table, Row, HeaderCell, Cell, Paragraph } from './styles';
import { FootnoteLink } from '../BasicTable/styles';

import { TableProps } from '../shared';

export function StandardTable({
  tableId,
  title,
  tableBody,
  tableFootnotes
}: TableProps) {
  const RICH_TEXT_OVERRIDES: RenderNode = {
    [BLOCKS.TABLE]: (_node, children) => (
      <Table>
        <tbody>{children}</tbody>
      </Table>
    ),
    [BLOCKS.TABLE_ROW]: (_node, children) => <Row>{children}</Row>,
    [BLOCKS.TABLE_HEADER_CELL]: (_node, children) => (
      <HeaderCell data-testid="st-header-cell">{children}</HeaderCell>
    ),
    [BLOCKS.TABLE_CELL]: (_node, children) => <Cell>{children}</Cell>,
    [BLOCKS.PARAGRAPH]: (_node, children) => <Paragraph>{children}</Paragraph>
  };

  return (
    <BlockContainer
      id={tableId!}
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-testid="standard-table"
    >
      <Layout>
        <Column size={{ 0: 12, tablet: 8 }} flexDirection="column">
          {title && (
            <Text
              textAlign="center"
              style={{ marginBottom: '2rem', fontWeight: 'bold' }}
            >
              {title}
            </Text>
          )}

          <RichText
            data={tableBody}
            overrideOptions={RICH_TEXT_OVERRIDES}
            overrideMarkOptions={{
              [MARKS.CODE]: (children) => (
                <FootnoteLink
                  id={`${tableId}-footnote-ref-${children}`.trim()}
                  href={`#${tableId}-footnote-${children}`.trim()}
                  aria-describedby={`${tableId}-footnotes`}
                  role="doc-noteref"
                >
                  <sup>{children}</sup>
                </FootnoteLink>
              )
            }}
          />

          {tableFootnotes && (
            <div id={`${tableId}-footnotes`}>
              <RichText
                data={tableFootnotes}
                overrideOptions={RICH_TEXT_OVERRIDES}
                overrideMarkOptions={{
                  [MARKS.CODE]: (children) => (
                    <FootnoteLink
                      id={`${tableId}-footnote-${children}`.trim()}
                      href={`#${tableId}-footnote-ref-${children}`.trim()}
                      aria-label={`Back to reference ${children}`}
                      role="doc-backlink"
                    >
                      <sup>{children}</sup>
                    </FootnoteLink>
                  )
                }}
              />
            </div>
          )}
        </Column>
      </Layout>
    </BlockContainer>
  );
}
